import dayjs from 'dayjs'

/** Номер сборки: YY-номерНабора-номерЗаказа. Собрать можно только после создания Form Order. */
export function buildFormNum(formSetId: number, orderId: number): string {
    return `${String(dayjs().year()).slice(2)}-${formSetId}-${orderId}`
}

/** Номер на формы: сборка + имя дизайнера + дата поставки — для копирования в макет / стороннюю систему */
export function buildExtendedOrderNum(
    formNum: string,
    designerName: string,
    estimatedDate: dayjs.Dayjs
): string {
    return `${formNum}-${designerName}-${estimatedDate.format('DD.MM.YYYY')}`
}
